import { render, staticRenderFns } from "./StreamingNotification.vue?vue&type=template&id=0a59ecfa&"
import script from "BASE/components/notification/streamingNotification.component?vue&type=script&lang=js&"
export * from "BASE/components/notification/streamingNotification.component?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports